import { EntityType } from '../../../@types/entityTypes';
import PurchaseLedgerJournalWorkspaceQuery from '../../queries/purchases/PurchaseLedgerJournalWorkspaceQuery.graphql';
import { ALLOW_ADD } from '../../../utils/OperationPermissions';

const PurchaseLedgerJournal: EntityType = {
  type: 'PurchaseLedgerJournal',
  title: 'Purchase Ledger Journals',
  workspaceUrl: '/Suppliers/PurchaseLedgerJournal/Workspace/',
  formUrl: '/Suppliers/PurchaseLedgerJournal/Details/',
  workspace: PurchaseLedgerJournalWorkspaceQuery,
  screenReference: 'PURCHASE_LEDGER_JOURNALS',
  operations: ALLOW_ADD,
};

export default PurchaseLedgerJournal;
